/**
 * Token 存取
 * 统一入口，便于后续替换为 cookie 或加密存储
 */
const TOKEN_KEY = 'job_front_token'
const REMEMBER_KEY = 'job_front_remember'

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function setToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token)
  } catch (e) {
    // 忽略存储异常（隐私模式等）
  }
}

export function removeToken() {
  try {
    localStorage.removeItem(TOKEN_KEY)
  } catch (e) {
    // 忽略
  }
}

/**
 * 记住的用户名（只存用户名，不存密码）
 */
export function getRememberedName() {
  try {
    return localStorage.getItem(REMEMBER_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function setRememberedName(name) {
  try {
    if (name) {
      localStorage.setItem(REMEMBER_KEY, name)
    } else {
      localStorage.removeItem(REMEMBER_KEY)
    }
  } catch (e) {
    // 忽略
  }
}